import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

import { UniverseReference } from '@front/common/src/types/commons';

import { translate } from '@front/i18n';

import TextButton from '@front/web-ui/src/components/button/text-button';
import Text from '@front/web-ui/src/components/base-text/variants/text';

import { trackSignInEvent } from '../../utils/tracking';

const t = translate('screens.signup');

const AlreadySubscribedWrap = styled.div`
  text-align: center;
  margin: 15px 0 0;
`;

type AlreadySubscribedProps = {
  openLoginScreen: () => void;
  universe: UniverseReference;
};

const AlreadySubscribed = ({ openLoginScreen, universe }: AlreadySubscribedProps) => {
  const location = useLocation();

  const onLoginClick = useCallback(() => {
    trackSignInEvent({
      eventType: 'AlreadySubscribedButtonClick',
      path: location.pathname,
      universe,
    });
    openLoginScreen();
  }, [location.pathname, openLoginScreen, universe]);

  return (
    <AlreadySubscribedWrap>
      <Text>{`${t('.login_question')}\u00a0`}</Text>
      <TextButton label={t('.login_link')} onClick={onLoginClick}>
        {t('.login_link')}
      </TextButton>
    </AlreadySubscribedWrap>
  );
};

export default memo(AlreadySubscribed);
